/**
 * Localization utilities
 * Provides translation functions and language management
 */

import { en } from './en';
import { uk } from './uk';

export type Language = 'uk' | 'en';

export const translations = {
  en,
  uk,
} as const;

export const LANGUAGE_OPTIONS = [
  { code: 'uk' as Language, name: 'Українська', flag: '\u{1F1FA}\u{1F1E6}' },
  { code: 'en' as Language, name: 'English', flag: '\u{1F1EC}\u{1F1E7}' },
] as const;

export const DEFAULT_LANGUAGE: Language = 'uk';

/**
 * Get nested value from translation object using dot notation
 * e.g., getNestedValue(translations.en, 'profile.title') => 'Profile'
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getNestedValue(obj: any, path: string): string {
  const keys = path.split('.');
  let result = obj;

  for (const key of keys) {
    if (result && typeof result === 'object' && key in result) {
      result = result[key];
    } else {
      return path; // Return the key if translation not found
    }
  }

  return typeof result === 'string' ? result : path;
}

/**
 * Create a translation function for a specific language
 */
export function createTranslator(language: Language) {
  const translationSet = translations[language] || translations[DEFAULT_LANGUAGE];

  return function t(key: string): string {
    return getNestedValue(translationSet, key);
  };
}

/**
 * Get translation for a specific key and language
 */
export function translate(key: string, language: Language): string {
  const translationSet = translations[language] || translations[DEFAULT_LANGUAGE];
  return getNestedValue(translationSet, key);
}

export { en, uk };
export type { TranslationKeys } from './en';
